import { CommonModule } from "@angular/common";
import {
    AfterContentInit,
    ChangeDetectorRef,
    Component,
    OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import {
    DxButtonModule,
    DxDataGridModule,
    DxLoadPanelModule,
    DxSwitchModule,
    DxTooltipModule,
} from "devextreme-angular";
import { CellPreparedEvent, OptionChangedEvent } from "devextreme/ui/data_grid";
import { finalize, timer } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AuthService } from "../../../core/services/auth.service";
import { SignalService } from "../../../core/services/loader.service";
import { LocaleService } from "../../../core/services/locale.service";
import { UserService } from "../../../core/services/user.service";
import { CalendarDatePipe } from "../../../core/utils/calendars-date.pipe";
import { showNotification } from "../../../core/utils/toast";
import { AgendaItem } from "../../../data/repositories/agenda/entities/agenda.model";
import { DisciplineDTO } from "../../../domain/models/discipline.model";
import { ProfessionalFigure } from "../../../domain/models/figure.model";
import { Geo } from "../../../domain/models/geo.model";
import { Practice } from "../../../domain/models/practice.model";
import { HrService } from "../agreement/services/hr.service";
import { CreateWorkloadModalComponent } from "./components/create-workload-modal/create-workload-modal.component";
import { PlanningWizardComponent } from "./components/planning-wizard/planning-wizard.component";
import { AgendaService } from "./services/agenda.service";
import { StringToMomentPipe } from "../../../core/utils/string-to-moment.pipe";

@Component({
    selector: "app-agenda",
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
        CreateWorkloadModalComponent,
        DxTooltipModule,
        DxLoadPanelModule,
        PlanningWizardComponent,
        DxSwitchModule,
        CalendarDatePipe,
        StringToMomentPipe
    ],
    templateUrl: "./agenda.component.html",
    styleUrl: "./agenda.component.scss",
})
export class AgendaComponent implements OnInit, AfterContentInit {
    // agendaDS!: DataSource;
    agendaDataSource: AgendaItem[] = [];
    isPopupVisible: boolean = false;
    isWizardVisible: boolean = false;
    isLoading: boolean = false;
    figures: ProfessionalFigure[] = [];
    geos: Geo[] = [];
    practices: Practice[] = [];
    disciplines: DisciplineDTO[] = [];
    wizardStartDate: string = "";
    wizardEndDate: string = "";
    wizardAgreementId: number = 0;
    wizardOpportunityId: number = 0;
    isCreateWorloadVisible: boolean = false;
    rinaId: string = "CMT";
    showingAgenda: boolean = true;
    pageSize = 20;
    wizardPep: { id: number; name: string } = {
        id: 0,
        name: "",
    };
    userRoleDescription: string = "";
    // gridFilter: any;

    constructor(
        public loaderService: SignalService,
        public localeService: LocaleService,
        private router: Router,
        private agendaService: AgendaService,
        private hrService: HrService,
        private authService: AuthService,
        private cd: ChangeDetectorRef,
        private userService: UserService,
    ) { }

    ngAfterContentInit(): void {
        this.loaderService.titleSignal.set("Agenda");
        this.cd.detectChanges();
    }

    ngOnInit() {
        this.isCreateWorloadVisible = !environment.production;

        console.log(visualViewport?.height);

        if (window.visualViewport?.height && window.visualViewport?.height < 700) {
            this.pageSize = 12;
        }

        let usr = this.authService.getProfile();

        if (usr) {
            this.rinaId = usr.username;

            let subStr = this.rinaId.indexOf("@");
            if (subStr > 0) this.rinaId = this.rinaId.substring(0, subStr);
            this.agendaService.getUserRole(this.rinaId).subscribe((res) => {
                this.userRoleDescription = res.userRole.roleDescription;
                console.log(res);
                this.isCreateWorloadVisible = res.userRole.userRole == 0;
            });
        }
        this.isLoading = true;
        if (this.loaderService.showWorkspace()) {
            this.loadWorkspace();
            this.showingAgenda = false;
        } else {
            this.loadAgendaItems();
            this.showingAgenda = true;
        }
    }

    // Handle disabled filter styles
    onCellPrepared(event: CellPreparedEvent) {
        if (event.rowType === "filter" && !event.column.allowFiltering) {
            event.cellElement.className = "agenda_disabled_filter";
        }
    }

    // After 3rd click on sorting order, returns to "neutral"
    onOptionChanged(e: OptionChangedEvent) {
        if (e.fullName.includes("sortOrder")) {
            let startIdx = e.fullName.indexOf("[") + 1,
                endIdx = e.fullName.indexOf("]");

            let idx = parseInt(e.fullName.slice(startIdx, endIdx));
            if (e.previousValue === "desc") {
                e.component.columnOption(idx, "sortOrder", undefined);
            }
        }
        // else if (e.fullName.includes('filter')) {
        //   localStorage.setItem("filters", JSON.stringify(e.component.getCombinedFilter(true)));
        // }
    }

    openCreateWorkload(): void {
        this.isPopupVisible = !this.isPopupVisible;
    }

    onCloseModal(agreementId: number | null) {
        this.isPopupVisible = false;
        if (agreementId) {
            timer(1000).subscribe((x) => {
                this.router.navigateByUrl(`/workload/${agreementId}`);
            });
        }
    }

    onCloseWizard(a: any) {
        this.isWizardVisible = false;
    }

    onClickAction(
        action: "report" | "accept" | "edit" | "wizard",
        row: AgendaItem,
        isNotification?: boolean,
    ): void {
        switch (action) {
            case "accept":
                const foundElement = this.agendaDataSource.find((x) => x.id === row.id);
                const index = this.agendaDataSource.findIndex((x) => x.id === row.id);
                if (foundElement) {
                    this.agendaService.sendNotification(row.id).subscribe({
                        next: (response) => {
                            showNotification("Notification read!", "info");
                            // Remove notification icon if it goes well
                            foundElement.displayed = !foundElement.displayed;
                            this.agendaDataSource = this.agendaDataSource.filter(
                                (x) => x.id !== response.id,
                            );

                            //cancellare questa riga
                            //this.agendaDataSource.splice(index, 0, response);
                        },
                        error: (err) => {
                            console.error(err);
                            showNotification(
                                "Error while sending notification to the server",
                                "error",
                            );
                        },
                    });
                }
                break;
            case "edit":
                switch (row.levelDesc) {
                    case "Opportunity":
                        this.router.navigate(["opportunity", row.agreementId]);
                        break;
                    case "Workload":
                        this.router.navigate(["workload", row.agreementId]);
                        break;
                    case "Proposal":
                        this.router.navigate(["proposal", row.agreementId]);
                        break;
                    case "Pre Staffing":
                        this.router.navigate(["prestaffing", row.agreementId]);
                        break;
                    case "Contract":
                        this.router.navigate(["contract", row.agreementId]);
                        break;
                }
                break;
            case "wizard":
                this.wizardStartDate = row.resultStartDate;
                this.wizardEndDate = row.resultEndDate;
                this.wizardAgreementId = row.agreementId;
                this.wizardOpportunityId = row.resultId;
                this.wizardPep.id = row.pepResourceId;

                if (this.figures.length == 0) {
                    this.hrService
                        .getAllFigures()
                        .subscribe((figures) => (this.figures = figures));
                }
                if (this.geos.length == 0) {
                    this.hrService.getAllGeos().subscribe((geos) => (this.geos = geos));
                }
                if (this.practices.length == 0) {
                    this.hrService
                        .getAllPractices()
                        .subscribe((practices) => (this.practices = practices));
                }
                if (this.geos.length == 0) {
                    this.hrService
                        .getAllDisciplines()
                        .subscribe((disciplines) => (this.disciplines = disciplines));
                }
                this.isWizardVisible = !this.isWizardVisible;
                break;
            default:
                break;
        }
    }

    loadAgendaItems() {
        this.loaderService.loadingSignal.set(true);
        this.agendaService
            .retrieveAgendaList(this.rinaId)
            .pipe(finalize(() => this.loaderService.loadingSignal.set(false)))
            .subscribe({
                next: (response) => {
                    if (!response || response.length === 0) {
                        showNotification("No data found for this agenda", "warning");
                    }
                    //this.agendaDataSource = response;
                    if (this.userRoleDescription === "Admin") {
                        this.agendaDataSource = response;
                    } else {
                        this.agendaDataSource = response.filter(item => !item.displayed);
                    }
                    // this.loadFilters();
                },
                error: (e) => {
                    console.error(e);
                    if (
                        e &&
                        e?.error?.errors?.length > 0 &&
                        e?.error?.errors[0]?.internalCode === "NoData"
                    ) {
                        showNotification("No data found for the specified user", "warning");
                    } else {
                        showNotification("Internal server error", "error");
                    }
                    this.agendaDataSource = [];
                },
            });
    }

    loadWorkspace() {
        this.loaderService.loadingSignal.set(true);
        this.agendaService
            .retrieveWorkspace(this.rinaId)
            .pipe(finalize(() => this.loaderService.loadingSignal.set(false)))
            .subscribe({
                next: (response) => {
                    if (!response || response.length === 0) {
                        showNotification("No data found for this agenda", "warning");
                    }
                    //this.agendaDataSource = response;
                    if (this.userRoleDescription === "Admin") {
                        this.agendaDataSource = response;
                    } else {
                        this.agendaDataSource = response.filter(item => !item.displayed);
                    }
                },
                error: (e) => {
                    console.error(e);
                    if (
                        e &&
                        e?.error?.errors?.length > 0 &&
                        e?.error?.errors[0]?.internalCode === "NoData"
                    ) {
                        showNotification("No data found for the specified user", "warning");
                    } else {
                        showNotification("Internal server error", "error");
                    }
                    this.agendaDataSource = [];
                },
            });
    }

    toggleWorkspace(event: any) {
        setTimeout(() => {
            if (this.showingAgenda) {
                this.loadWorkspace();
                this.showingAgenda = false;
            } else {
                this.loadAgendaItems();
                this.showingAgenda = true;
            }
            this.loaderService.showWorkspace.update((value) => !value);
        }, 10);
    }

    updateData() {
        if (this.showingAgenda) {
            this.loadAgendaItems();
        } else {
            this.loadWorkspace();
        }
    }

    // loadFilters() {
    //   let storedFilters = localStorage.getItem("filters");
    //   if (storedFilters) {
    //     this.gridFilter = JSON.parse(storedFilters);
    //   } else {
    //     this.gridFilter = null;
    //   }
    // }
}
